// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1KkdA","link":"Pagination_link__G-0N5","active":"Pagination_active__3SYsN","title":"Pagination_title__Fj6Hg"};